/**
 * Constants used by the ConfigContext.
 */

/**
 * The key used to store the main configuration in local storage.
 */
export const CONFIG_LOCAL_STORAGE_KEY = 'ergogen:config';
